// extracted by mini-css-extract-plugin
module.exports = {"info":"Dialog__info___2GyYa"};